import React, { useEffect, useState } from 'react';
import { getAllMarketData } from '../../api/marketIntelligency';
import { Link } from 'react-router-dom';
import { getAllOrder } from '../../api/products';
import ModalOrderLIst from './ModalOrderLIst';

function OrderList(props) {
  const [orderData, setOrderData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleOrderClick = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };

  // Function to format date and remove time - handles ISO format
  const formatDateOnly = (dateTimeString) => {
    if (!dateTimeString) return '';
    
    try {
      // Handle ISO format like "2025-10-02T00:00:00.000Z"
      if (dateTimeString.includes('T')) {
        const datePart = dateTimeString.split('T')[0];
        return datePart;
      }
      
      // Handle space-separated format like "2025-10-02 14:30:22"
      if (dateTimeString.includes(' ')) {
        const datePart = dateTimeString.split(' ')[0];
        return datePart;
      }
      
      // If it's already just a date, return as is
      return dateTimeString;
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateTimeString;
    }
  };

  function getDataTable() {
    setLoading(true);
    getAllOrder((result) => {
      if (result.ok !== 1) {
        console.log(result);
        setLoading(false);
        return;
      }
      setOrderData(result.result);
      setLoading(false);
    });
  }

  useEffect(() => {
    getDataTable();
  }, []);

  const filteredData = orderData.filter(item => {
    const matchesSearch = item.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.farmer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.orderID?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === 'all' || 
                         (filterStatus === 'pending' && item.status === 'Pending') ||
                         (filterStatus === 'completed' && item.status === 'Completed') ||
                         (filterStatus === 'cancelled' && item.status === 'Cancelled');
    return matchesSearch && matchesFilter;
  });

  const pendingCount = orderData.filter(item => item.status === 'Pending').length;
  const completedCount = orderData.filter(item => item.status === 'Completed').length;
  const cancelledCount = orderData.filter(item => item.status === 'Cancelled').length;

  const OrderCard = ({ item, index }) => (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex align-items-center flex-grow-1">
            <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" style={{width: '40px', height: '40px'}}>
              <i className="bi bi-cart-fill text-success"></i>
            </div>
            <div className="flex-grow-1 min-w-0">
              <h6 className="mb-1 fw-bold text-truncate">{item.product_name}</h6>
              <small className="text-muted d-block">
                <i className="bi bi-hash me-1"></i>
                Order #{index + 1}
              </small>
            </div>
          </div>
          <div className="flex-shrink-0">
            {item.status === 'Pending' ? (
              <span className="badge bg-warning">
                <i className="bi bi-clock me-1"></i>
                Pending
              </span>
            ) : item.status === 'Completed' ? (
              <span className="badge bg-success">
                <i className="bi bi-check-circle me-1"></i>
                Completed
              </span>
            ) : (
              <span className="badge bg-danger">
                <i className="bi bi-x-circle me-1"></i>
                Cancelled
              </span>
            )}
          </div>
        </div>

        <div className="row g-2 mb-3">
          <div className="col-6">
            <small className="text-muted d-block">Quantity</small>
            <small className="fw-medium">{item.quantity}</small>
          </div>
          <div className="col-6">
            <small className="text-muted d-block">Total Price</small>
            <small className="fw-medium text-success">{item.currency_name} {item.total_price}/=</small>
          </div>
          <div className="col-6">
            <small className="text-muted d-block">Trader</small>
            <small className="fw-medium">{item.farmer_name}</small>
          </div>
          <div className="col-6">
            <small className="text-muted d-block">Client</small>
            <small className="fw-medium">{item.user_name}</small>
          </div>
        </div>

        <div className="d-grid">
          <button
            onClick={() => handleOrderClick(item)}
            className="btn btn-outline-primary btn-sm"
          >
            <i className="bi bi-eye me-1"></i>
            View Order Details
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-3 p-md-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div className="row">
        <div className="col-12">
          {/* Header */}
          <div className="mb-4">
            <h2 className="mb-1 fw-bold">Order Management</h2>
            <p className="text-muted">Track and manage all customer orders</p>
          </div>

          {/* Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Total Orders</p>
                      <h3 className="mb-0 fw-bold">{orderData.length}</h3>
                    </div>
                    <div className="bg-primary bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-cart fs-4 text-primary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Pending</p>
                      <h3 className="mb-0 fw-bold text-warning">{pendingCount}</h3>
                    </div>
                    <div className="bg-warning bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-clock fs-4 text-warning"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Completed</p>
                      <h3 className="mb-0 fw-bold text-success">{completedCount}</h3>
                    </div>
                    <div className="bg-success bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-check-circle fs-4 text-success"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Cancelled</p>
                      <h3 className="mb-0 fw-bold text-danger">{cancelledCount}</h3>
                    </div>
                    <div className="bg-danger bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-x-circle fs-4 text-danger"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filters and Search */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-12">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <i className="bi bi-search text-muted"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search by product, trader, client, or order ID..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="d-flex gap-2 flex-wrap align-items-center">
                    <button
                      onClick={() => setFilterStatus('all')}
                      className={`btn btn-sm ${filterStatus === 'all' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    >
                      All
                    </button>
                    <button
                      onClick={() => setFilterStatus('pending')}
                      className={`btn btn-sm ${filterStatus === 'pending' ? 'btn-warning' : 'btn-outline-secondary'}`}
                    >
                      Pending
                    </button>
                    <button
                      onClick={() => setFilterStatus('completed')}
                      className={`btn btn-sm ${filterStatus === 'completed' ? 'btn-success' : 'btn-outline-secondary'}`}
                    >
                      Completed
                    </button>
                    <button
                      onClick={() => setFilterStatus('cancelled')}
                      className={`btn btn-sm ${filterStatus === 'cancelled' ? 'btn-danger' : 'btn-outline-secondary'}`}
                    >
                      Cancelled
                    </button>
                    <button
                      onClick={getDataTable}
                      disabled={loading}
                      className="btn btn-sm btn-outline-secondary ms-auto"
                      title="Refresh"
                    >
                      <i className={`bi bi-arrow-clockwise ${loading ? 'spinner-border spinner-border-sm' : ''}`}></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : filteredData.length === 0 ? (
            <div className="text-center py-5">
              <i className="bi bi-cart-x fs-1 text-muted"></i>
              <p className="text-muted mt-2">No orders found</p>
            </div>
          ) : (
            <>
              {/* Mobile Card View (visible on small and medium screens) */}
              <div className="d-block d-xl-none">
                {filteredData.map((item, index) => (
                  <OrderCard key={index} item={item} index={index} />
                ))}
              </div>

              {/* Desktop Table View (visible on extra large screens) */}
              <div className="card border-0 shadow-sm d-none d-xl-block">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '60px'}}>#</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '150px'}}>Product</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '100px'}}>Quantity</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '120px'}}>Total Price</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '150px'}}>Trader</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '150px'}}>Client</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '100px'}}>Status</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '100px'}}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((item, index) => (
                          <tr key={index}>
                            <td className="text-nowrap">
                              <small className="text-muted fw-medium">#{index + 1}</small>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '32px', height: '32px'}}>
                                  <i className="bi bi-cart-fill text-success small"></i>
                                </div>
                                <span className="fw-medium text-truncate" style={{maxWidth: '120px'}} title={item.product_name}>{item.product_name}</span>
                              </div>
                            </td>
                            <td className="text-nowrap">
                              <span className="fw-medium">{item.quantity}</span>
                            </td>
                            <td className="text-nowrap">
                              <span className="fw-medium text-success">{item.currency_name} {item.total_price}/=</span>
                            </td>
                            <td>
                              <span className="fw-medium text-truncate d-block" style={{maxWidth: '120px'}} title={item.farmer_name}>
                                {item.farmer_name}
                              </span>
                            </td>
                            <td>
                              <span className="fw-medium text-truncate d-block" style={{maxWidth: '120px'}} title={item.user_name}>
                                {item.user_name}
                              </span>
                            </td>
                            <td>
                              {item.status === 'Pending' ? (
                                <span className="badge bg-warning">
                                  <i className="bi bi-clock me-1"></i>
                                  Pending
                                </span>
                              ) : item.status === 'Completed' ? (
                                <span className="badge bg-success">
                                  <i className="bi bi-check-circle me-1"></i>
                                  Completed
                                </span>
                              ) : (
                                <span className="badge bg-danger">
                                  <i className="bi bi-x-circle me-1"></i>
                                  Cancelled
                                </span>
                              )}
                            </td>
                            <td>
                              <button
                                onClick={() => handleOrderClick(item)}
                                className="btn btn-sm btn-outline-primary"
                              >
                                <i className="bi bi-eye me-1"></i>
                                View
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Footer */}
          <div className="mt-3 text-center text-muted small">
            Showing {filteredData.length} of {orderData.length} orders
          </div>
        </div>
      </div>

      <ModalOrderLIst 
        show={showModal} 
        handleClose={handleCloseModal} 
        event={selectedEvent}
      />
    </div>
  );
}

export default OrderList;